<template>
  <page-list
    :list="list"
    :columns="columns"
    :group-actions="groupActions"
    :single-actions="singleActions"
    :export-data-options="exportDataOptions" />
</template>

<script>
import ListMixin from '@/mixins/list'
import WindowsMixin from '@/mixins/windows'
import { getNameFilter } from '@/utils/common/tableFilter'
import { getProjectDomainTableColumn, getPublicScopeTableColumn, getTimeTableColumn } from '@/utils/common/tableColumn'
import { getSetPublicAction } from '@/utils/common/tableActions'

export default {
  name: 'PreDefinedTagsList',
  mixins: [WindowsMixin, ListMixin],
  props: {
    id: {
      type: String,
      required: false,
    },
  },
  data () {
    return {
      list: this.$list.createList(this, {
        id: this.id,
        resource: 'tags',
        getParams: this.getParam,
        filterOptions: {
          name: getNameFilter(),
        },
      }),
      columns: [
        {
          field: 'name',
          title: this.$t('system.text_101'),
        },
        {
          field: 'value',
          title: this.$t('system.text_102'),
          slots: {
            default: ({ row }) => {
              const tags = row.values || []
              if (!tags.length) {
                return '-'
              }
              const list = tags.map(tag => <a-tag class='mb-2 mr-1' color='blue'>{tag}</a-tag>)
              return [
                <div style="display: inline-flex; flex-wrap: wrap">
                  {...list}
                </div>,
              ]
            },
          },
          formatter: ({ row }) => {
            return row.values.join(',')
          },
        },
        getProjectDomainTableColumn(),
        getPublicScopeTableColumn(),
        getTimeTableColumn(),
      ],
      groupActions: [
        {
          label: this.$t('common_117'),
          permission: 'tags_create',
          action: () => {
            this.createDialog('PreDefinedTagCreateDialog', {
              vm: this,
              onManager: this.onManager,
            })
          },
          meta: () => {
            return {
              buttonType: 'primary',
            }
          },
        },
        {
          label: this.$t('table.action.delete'),
          permission: 'tags_delete',
          action: () => {
            this.createDialog('DeleteResDialog', {
              vm: this,
              data: this.list.selectedItems,
              columns: this.columns,
              title: this.$t('table.action.delete'),
              name: this.$t('system.pre_defined_tags'),
              onManager: this.onManager,
            })
          },
          meta: () => {
            const ret = { validate: this.list.selected.length }
            if (this.list.selectedItems.some(item => !item.can_delete)) {
              ret.validate = false
              return ret
            }
            return ret
          },
        },
      ],
      singleActions: [
        {
          label: this.$t('system.text_152'),
          permission: 'tags_update',
          action: (obj) => {
            this.createDialog('PreDefinedTagCreateDialog', {
              vm: this,
              onManager: this.onManager,
              type: 'update',
              data: [obj],
              refresh: () => {
                this.list.fetchData()
              },
            })
          },
        },
        getSetPublicAction(this, {
          name: this.$t('system.pre_defined_tags'),
          scope: 'domain',
          resource: 'tags',
        }, {
          permission: 'tags_perform_set_public',
        }),
        {
          label: this.$t('table.action.delete'),
          permission: 'tags_delete',
          action: (obj) => {
            this.createDialog('DeleteResDialog', {
              vm: this,
              data: [obj],
              columns: this.columns,
              title: this.$t('table.action.delete'),
              name: this.$t('system.pre_defined_tags'),
              onManager: this.onManager,
            })
          },
          meta: (obj) => {
            const ret = { validate: true }
            if (!obj.can_delete) {
              ret.validate = false
              return ret
            }
            return ret
          },
        },
      ],
    }
  },
  computed: {
    exportDataOptions () {
      return {
        exportType: 'local',
        title: this.$t('system.pre_defined_tags'),
        items: this.columns,
      }
    },
  },
  created () {
    this.list.fetchData()
  },
  methods: {
    getParam () {
      // 目前只透传基础参数，后续有需求可在此扩展
      return {}
    },
  },
}
</script>
